import React from 'react';

const statusConfig = {
  quote_requested: {
    label: 'Quote Requested',
    className: 'status-quote-requested',
  },
  in_costing: {
    label: 'In Costing',
    className: 'status-in-costing',
  },
  pending_approval: {
    label: 'Pending Approval',
    className: 'status-pending-approval',
  },
  confirmed: {
    label: 'Waybill Submitted',
    className: 'status-confirmed',
  },
  acknowledged: {
    label: 'Accepted',
    className: 'status-accepted',
  },
  quote_ready: {
    label: 'Quote Sent',
    className: 'status-quote-ready',
  },
  accepted: {
    label: 'Quote Accepted',
    className: 'status-accepted',
  },
  waybill_submitted: {
    label: 'Waybill Submitted',
    className: 'status-confirmed',
  },
  dispatch_scheduled: {
    label: 'Dispatch Scheduled',
    className: 'status-dispatch-scheduled',
  },
  collected: {
    label: 'Collected',
    className: 'status-collected',
  },
  in_transit: {
    label: 'In Transit',
    className: 'status-in-transit',
  },
  at_customs: {
    label: 'At Customs',
    className: 'status-at-customs',
  },
  out_for_delivery: {
    label: 'Out for Delivery',
    className: 'status-out-for-delivery',
  },
  delivered: {
    label: 'Delivered',
    className: 'status-delivered',
  },
  delayed: {
    label: 'Delayed',
    className: 'status-delayed',
  },
  declined: {
    label: 'Declined',
    className: 'status-declined',
  },
  cancelled: {
    label: 'Cancelled',
    className: 'status-cancelled',
  },
  note: {
    label: 'Note',
    className: 'bg-amber-50 text-amber-700 border border-amber-200',
  },
  quantity_adjusted: {
    label: 'Qty Adjusted',
    className: 'bg-purple-50 text-purple-700 border border-purple-200',
  },
};

const StatusBadge = ({ status, className = '' }) => {
  const config = statusConfig[status] || {
    label: status?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) || 'Unknown',
    className: 'bg-slate-100 text-slate-600',
  };

  return (
    <span
      className={`status-badge ${config.className} ${className}`}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
};

export const getStatusLabel = (status) => {
  return statusConfig[status]?.label || status?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) || 'Unknown';
};

export default StatusBadge;
